/**
 * @generated SignedSource<<517565573a629faadd65bbcfa4475620>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteHolidayCalendarEntryInput = {
  id: string;
  holidayCalendarId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteHolidayCalendarEntryMutation$variables = {
  input: DeleteHolidayCalendarEntryInput;
};
export type deleteHolidayCalendarEntryMutation$data = {
  readonly deleteHolidayCalendarEntry: {
    readonly deletedHolidayCalendarEntryId: string | null;
  } | null;
};
export type deleteHolidayCalendarEntryMutation = {
  variables: deleteHolidayCalendarEntryMutation$variables;
  response: deleteHolidayCalendarEntryMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteHolidayCalendarEntryPayload",
    "kind": "LinkedField",
    "name": "deleteHolidayCalendarEntry",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedHolidayCalendarEntryId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteHolidayCalendarEntryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteHolidayCalendarEntryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "252e48430190f05485508ae802cb06b2",
    "id": null,
    "metadata": {},
    "name": "deleteHolidayCalendarEntryMutation",
    "operationKind": "mutation",
    "text": "mutation deleteHolidayCalendarEntryMutation(\n  $input: DeleteHolidayCalendarEntryInput!\n) {\n  deleteHolidayCalendarEntry(input: $input) {\n    deletedHolidayCalendarEntryId\n  }\n}\n"
  }
};
})();

(node as any).hash = "b109b7c61b2d09c3704c94e992d64c2d";

export default node;
